module.exports = __webpack_public_path__ + "home_coding.ba693a79a465de9f0ba3.gif";